/**
 * Base generic icon registry for grid action columns.
 *
 * Maps icon names emitted by the backend grid-spec descriptor to MUI icon
 * components. ODL injects this registry via DataGridConfigProvider; consuming
 * grids resolve icon names through config.resolveActionIcon(). The base set
 * covers the names the odl_app BE descriptor currently emits — extend via the
 * ODL config or a future custom provider.
 *
 * Contains:
 * - BASE_ACTION_ICON_REGISTRY — seed map of icon name → MUI icon component
 * - resolveActionIcon          — looks up a name in a registry, null for unknowns
 */

import EditIcon from '@mui/icons-material/Edit';
import LaunchIcon from '@mui/icons-material/Launch';

/** @type {Record<string, React.ComponentType>} */
export const BASE_ACTION_ICON_REGISTRY = {
  edit: EditIcon,
  open: LaunchIcon,
};

/**
 * Returns the MUI icon component registered under `name`, or null if the name
 * has no entry. Grids render null icons as absent rather than crashing.
 *
 * @param {string} name  Icon name from the backend descriptor.
 * @param {Record<string, React.ComponentType>} [registry]  Registry to look up.
 *   Defaults to BASE_ACTION_ICON_REGISTRY.
 * @returns {React.ComponentType|null}
 */
export function resolveActionIcon(name, registry = BASE_ACTION_ICON_REGISTRY) {
  return (registry && registry[name]) ?? null;
}
